import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './style.css';

function getRouterBasename() {
  const publicUrl = process.env.PUBLIC_URL || '';

  if (!publicUrl || publicUrl === '.') {
    return '/';
  }

  try {
    const parsed = publicUrl.startsWith('http')
      ? new URL(publicUrl)
      : new URL(publicUrl, window.location.origin);
    const pathname = parsed.pathname.replace(/\/$/, '');
    return pathname || '/';
  } catch (_error) {
    const normalized = publicUrl.replace(/https?:\/\/[^/]+/, '').replace(/\/$/, '');
    return normalized || '/';
  }
}

const routerBasename = getRouterBasename();
const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <BrowserRouter basename={routerBasename}>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

const isProductionHost =
  window.location.hostname === 'www.pomodoro-flow.click' ||
  window.location.hostname === 'pomodoro-flow.click';

async function cleanupServiceWorkersAndCaches() {
  if ('serviceWorker' in navigator) {
    const registrations = await navigator.serviceWorker.getRegistrations();
    await Promise.all(registrations.map((registration) => registration.unregister()));
  }

  if ('caches' in window) {
    const cacheNames = await caches.keys();
    await Promise.all(
      cacheNames
        .filter((name) => name.startsWith('pomodoro-cache-'))
        .map((name) => caches.delete(name))
    );
  }
}

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    if (isProductionHost) {
      const serviceWorkerPath = `${routerBasename === '/' ? '' : routerBasename}/sw.js`;
      navigator.serviceWorker.register(serviceWorkerPath)
        .then((registration) => {
          console.log('ServiceWorker registered with scope:', registration.scope);
        })
        .catch((error) => {
          console.error('ServiceWorker registration failed:', error);
        });
    } else {
      cleanupServiceWorkersAndCaches().catch((error) => {
        console.error('ServiceWorker cleanup failed:', error);
      });
    }
  });
}
